export interface LeaveType {
  value: string;
  label: string;
  category?: 'paid' | 'unpaid' | 'special';
}

export const LEAVE_TYPES: LeaveType[] = [
  { 
    value: 'annual_leave_vacation', 
    label: 'Annual Leave (Vacation)',
    category: 'paid'
  },
  { 
    value: 'bereavement_compassionate', 
    label: 'Bereavement (Compassionate)',
    category: 'special'
  },
  { 
    value: 'carers_leave', 
    label: "Carer's Leave",
    category: 'special'
  },
  { 
    value: 'maternity_leave', 
    label: 'Maternity Leave',
    category: 'special'
  },
  { 
    value: 'community_service_leave', 
    label: 'Community Service Leave',
    category: 'special'
  },
  { 
    value: 'long_service_leave', 
    label: 'Long Service Leave',
    category: 'paid'
  },
  { 
    value: 'other_paid_leave', 
    label: 'Other Paid Leave',
    category: 'paid'
  },
  { 
    value: 'sick_personal_carers_leave', 
    label: "Sick (Personal/Carer's) Leave",
    category: 'paid'
  },
  { 
    value: 'time_off_in_lieu', 
    label: 'Time Off In Lieu',
    category: 'paid'
  },
  { 
    value: 'unpaid_leave', 
    label: 'Unpaid Leave - Leave',
    category: 'unpaid'
  },
  { 
    value: 'unpaid_leave_no_show', 
    label: 'Unpaid Leave - No Show',
    category: 'unpaid'
  },
  { 
    value: 'unpaid_leave_sick', 
    label: 'Unpaid Leave - Sick',
    category: 'unpaid'
  }
];

export const getLeaveTypeLabel = (value: string): string => {
  const leaveType = LEAVE_TYPES.find(type => type.value === value);
  return leaveType?.label || value;
};

export const getLeaveTypesByCategory = (category?: 'paid' | 'unpaid' | 'special') => {
  if (!category) return LEAVE_TYPES;
  return LEAVE_TYPES.filter(type => type.category === category);
};